import { StyleSheet } from 'aphrodite';
import { brandPrimary, destructive, header, white } from '../../styles/colors';
import { shadowSm } from '../../styles/shadows';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	group: {
		display: 'grid',
		width: '100%',
		gap: THEME.spacing.sm,
	},
	item: {
		position: 'relative',
		display: 'grid',
		placeContent: 'center',
		boxSizing: 'border-box',
		flexShrink: 0,
		border: `1px solid ${header}`,
		borderRadius: '50%',
		backgroundColor: white,
		boxShadow: shadowSm,
		outline: 'none',
		cursor: 'pointer',
		transition: 'background-color 150ms ease, border-color 150ms ease',
		'::after': {
			content: '""',
			position: 'absolute',
			top: -THEME.spacing.sm,
			right: -12,
			bottom: -THEME.spacing.sm,
			left: -12,
		},
		':is([data-checked])': {
			backgroundColor: THEME.colors.primary.main,
			borderColor: THEME.colors.primary.main,
			color: white,
		},
		':is([data-disabled])': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		':is([data-readonly])': {
			cursor: 'default',
		},
		':focus-visible': {
			borderColor: THEME.colors.primary.main,
			boxShadow: `0 0 0 3px ${brandPrimary}4d`,
		},
		':is([aria-invalid="true"])': {
			borderColor: destructive,
		},
	},
	md: {
		width: 14,
		height: 14,
	},
	lg: {
		width: 16,
		height: 16,
	},
	indicator: {
		borderRadius: '50%',
		backgroundColor: 'currentColor',
	},
	mdIndicator: {
		width: 6,
		height: 6,
	},
	lgIndicator: {
		width: 7,
		height: 7,
	},
});
